module.exports = __webpack_public_path__ + "img/symbol_6.7bc42ae9.png";